module.exports = __webpack_public_path__ + "static/media/DLL.252dc4c5.svg";